export const DEFAULT_TEXT_COLOR = '#FFFFFF';
export const DEFAULT_BACKGROUND_COLOR = '#171718';

export const DISABLED_TEXT_COLOR = '#FFFFFF';
export const DISABLED_BACKGROUND_COLOR = '#B2B3B7';

export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;

export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;

export const TICK_INTERVAL_MS = MS_PER_SECOND;

export const PROPS = {
    END: 'end',
    NOW: 'now',
};

export const CONSOLE_MESSAGE = {
    MISSING_END: 'End date must be specified for sotbit-timer to work',
    NO_TIME_REMAINING: 'No time remaining for sotbit-timer',
};
